const platformCapabilitiesMini = {
    Controllers: [
        {
            ControllerUUID: "dummy-mini-uuid-1234",
            Modules: [
                {
                    PortTypes: {
                        Bus: [
                            {
                                PortNumber: 1
                            },
                            {
                                PortNumber: 2
                            }
                        ],
                        HighVoltage: [
                            {
                                PortNumber: 1
                            },
                            {
                                PortNumber: 2
                            }
                        ],
                        LowVoltage: [
                            {
                                PortNumber: 1
                            },
                            {
                                PortNumber: 2
                            }
                        ],
                        Actuator: [
                            {
                                PortNumber: 1
                            },
                            {
                                PortNumber: 2
                            },
                            {
                                PortNumber: 3
                            }
                        ],
                        Thermistor: [
                            {
                                PortNumber: 1
                            },
                            {
                                PortNumber: 2
                            }
                        ],
                        FlowSwitch: [
                            {
                                PortNumber: 1
                            },
                            {
                                PortNumber: 2
                            }
                        ],
                        ChemistryPH: [
                            {
                                PortNumber: 1
                            }
                        ],
                        ChemistryORP: [
                            {
                                PortNumber: 1
                            }
                        ],
                        Ma: [
                            {
                                PortNumber: 1
                            },
                            {
                                PortNumber: 2
                            }
                        ],
                        InterfaceButtons: [
                            {
                                PortNumber: 3
                            },
                            {
                                PortNumber: 4
                            }
                        ]
                    },
                    ModuleNumber: "1"
                }
            ]
        }
    ]
}
export default platformCapabilitiesMini;